import { connect } from 'react-redux'
import { IStoreState, ITripEdit } from '../../types'
import * as actions from '../../state/actions/trips'
import ManualTripCancelModal from '../../components/trips/ManualTripCancelModal'

export function mapStateToProps(state: IStoreState, ownProps: any): any {
  const currentTripId = ownProps.match.params.tripId
  const currentTrip = state.trips.items[currentTripId]
  return {
    currentTripId,
    currentTrip,
    close: ownProps.history.goBack,
    loading: state.trips.isFetching
  }
}

export function mapDispatchToProps(dispatch: any) {
  return {
    cancelTrip: async (tripId: string, comment: string): Promise<any> => {
      return await dispatch(actions.cancelTrip(tripId, comment))
    },
    getTripById: (tripId: string) => {
      return dispatch(actions.getTripById(tripId))
    },
    saveData: async (params: ITripEdit): Promise<any> => {
      return await dispatch(actions.saveData(params))
    }
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ManualTripCancelModal)



// WEBPACK FOOTER //
// ./src/containers/trips/ManualTripCancelModal.ts